import { Directive, ElementRef, forwardRef, HostListener, Input, OnInit, Renderer2 } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Directive({
  selector: 'input[type=checkbox][trueFalseValue]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormCheckboxValueDirective),
      multi: true
    }
  ]
})
export class FormCheckboxValueDirective implements ControlValueAccessor, OnInit {

  @Input() public trueValue: any = true;
  @Input() public falseValue: any = false;

  constructor(private elementRef: ElementRef, private renderer: Renderer2) {
  }

  private propagateChange = (_: any) => {
  };

  ngOnInit() {
    setTimeout(() => {
      this.propagateChange(this.elementRef.nativeElement.checked ? this.trueValue : this.falseValue);
    });
  }

  @HostListener('change', ['$event'])
  onHostChange(ev: any) {
    this.propagateChange(ev.target.checked ? this.trueValue : this.falseValue);
  }

  writeValue(obj: any): void {
    if (obj === this.trueValue) {
      this.renderer.setProperty(this.elementRef.nativeElement, 'checked', true);
    } else {
      this.renderer.setProperty(this.elementRef.nativeElement, 'checked', false);
    }
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  setDisabledState?(isDisabled: boolean): void {
  }
}
